<template>
  <div class="login-container">
    <el-form :model="form" class="login-form" @submit.native.prevent="onLogin">
      <h2 class="title">后台登录</h2>
      <el-form-item>
        <el-input v-model="form.username" placeholder="用户名" />
      </el-form-item>
      <el-form-item>
        <el-input v-model="form.password" type="password" placeholder="密码" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onLogin" :loading="loading" style="width:100%">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Login',
  data() {
    return {
      form: { username: '', password: '' },
      loading: false
    };
  },
  methods: {
    async onLogin() {
      this.loading = true;
      try {
        const res = await axios.post('/api/admin/login', this.form);
        if (res.data.code === 0) {
          localStorage.setItem('token', res.data.token);
          this.$router.push('/dashboard');
        } else {
          this.$message.error(res.data.msg);
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f6fa;
}
.login-form {
  width: 350px;
  padding: 40px 30px 30px 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
}
.title {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}
</style> 